import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchSettings } from "../lib/api";

export const Footer = () => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        fetchSettings()
            .then(setSettings)
            .catch(() => {});
    }, []);

    return (
        <footer
            data-testid="site-footer"
            className="border-t border-border mt-32 px-6 sm:px-10 lg:px-14 py-16"
        >
            <div className="mx-auto max-w-[1500px] grid gap-12 lg:grid-cols-3">
                <div>
                    <p className="text-label text-muted-foreground mb-4">Studio</p>
                    <p className="font-serif-display text-2xl">
                        John Alexander Jimenez
                    </p>
                    <p className="text-sm text-muted-foreground mt-2 max-w-sm leading-relaxed">
                        Cinematographer & Director. Based in Sacramento,
                        California. Available worldwide.
                    </p>
                </div>

                <div>
                    <p className="text-label text-muted-foreground mb-4">Index</p>
                    <ul className="space-y-3">
                        {[
                            ["/work", "Selected Work"],
                            ["/about", "About"],
                            ["/awards", "Awards"],
                            ["/contact", "Contact"],
                        ].map(([to, label]) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="underline-anim text-sm text-foreground/80 hover:text-foreground"
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="text-label text-muted-foreground mb-4">Connect</p>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <a
                                href={`mailto:${settings?.contact_email || "hello@johnalexanderjimenez.com"}`}
                                data-testid="footer-email"
                                className="underline-anim text-foreground/80 hover:text-foreground"
                            >
                                {settings?.contact_email || "hello@johnalexanderjimenez.com"}
                            </a>
                        </li>
                        <li>
                            <a
                                href={settings?.instagram_url || "https://instagram.com/"}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-instagram"
                                className="underline-anim text-foreground/80 hover:text-foreground"
                            >
                                Instagram
                            </a>
                        </li>
                        <li>
                            <a
                                href={
                                    settings?.threads_url ||
                                    "https://www.threads.com/@j_alexander_jimenez"
                                }
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-threads"
                                className="underline-anim text-foreground/80 hover:text-foreground"
                            >
                                Threads
                            </a>
                        </li>
                        <li>
                            <a
                                href={settings?.imdb_url || "https://www.imdb.com/"}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-imdb"
                                className="underline-anim text-foreground/80 hover:text-foreground"
                            >
                                IMDb
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mx-auto max-w-[1500px] mt-16 pt-8 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <p className="text-xs text-muted-foreground tracking-wider">
                    © {new Date().getFullYear()} John Alexander Jimenez. All rights reserved.
                </p>
                <p className="text-xs text-muted-foreground tracking-wider">
                    Sacramento — California
                </p>
            </div>
        </footer>
    );
};

export default Footer;
